import gql from 'graphql-tag'
export default gql`mutation deleteTypeOfWorkMutation($typeOfWorkId: Int!) {
  deleteTypeOfWork(typeOfWorkId: $typeOfWorkId) {
    success
  }
}`